import Button from "Components/button";
import classNames from "classnames";
import React from "react";
import NodeAttributeForm from "../../nodeAttributeEditor/nodeAttributeForm";
import locale from "./nodeAttributeCreator.locale";
import Styled from "./nodeAttributeCreator.styled";
export default function NodeAttributeCreator(props) {
    return (React.createElement("div", { className: classNames("grid-rows-1fr-auto", props.className) },
        React.createElement(Styled.FormContainer, { className: "grid-cols-2 align-content-start" },
            React.createElement(NodeAttributeForm, { data: props.draft, onDataUpdate: props.onChangeDraft, showRequired: true, showRequiredErrors: props.showRequiredErrors })),
        React.createElement("div", { className: "d-flex justify-content-flex-end mt-24 with-gap-8" },
            React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: props.onResetDraft, disabled: !props.hasChanges }),
            React.createElement(Button, { text: locale.CREATE, className: "btn-primary btn-h-m p-8-24", disabled: !props.hasChanges, onClick: props.onAdd }))));
}
